module.exports = __webpack_public_path__ + "img/vxgi.cf6a877a.jpg";